import React from 'react';
import { useNavigate } from 'react-router-dom';

// Material UI
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';

// FontAwesomeIcons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDna } from '@fortawesome/free-solid-svg-icons'

import { Grid } from '@mui/material';

const pages = [
  {
    label:'Search for siRNA',
    route:'/search'
  },
  {
    label:'My Searches',
    route:'/searches'
  }
];

// Import our store

// Types
interface Props {

}

const Navbar = ({}: Props) => {
  // We want the buttons in the menu bar to be able to navigate to the various pages
  const navigate = useNavigate();

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <Box width={'100%'}>
      <AppBar position="fixed">
        <Container maxWidth="xl" sx={{ maxHeight: '64px' }}>
          <Toolbar disableGutters sx={{ maxHeight: '64px' }}>
            {/* Left-side Icon */}
            <Box style={{ paddingRight: '16px' }}>
              <FontAwesomeIcon icon={faDna} size="xl" />
            </Box>

            {/* App title with flexGrow to take available space */}
            <Typography
              variant="h6"
              noWrap
              component="a"
              sx={{
                flexGrow: 1, // This makes it take up available space
                fontWeight: 600,
                color: 'inherit',
                textDecoration: 'none',
                cursor: 'pointer',
                fontSize: { xs: 12, sm: 13, md: 18, lg: 24 },
              }}
              onClick={() => {
                navigate('/');
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  AI-powered Therapeutic siRNA Design Portal
                </Grid>
                <Grid item xs={12}>
                  <Typography>(beta version)</Typography>
                </Grid>
              </Grid>
            </Typography>

            {/* Pushes content to fill between title and menu */}
            <Box sx={{ flexGrow: 1 }} />

            {/* Hamburger Menu */}
            <Box sx={{ maxHeight: '64px' }}>
              <IconButton
                size="large"
                aria-label="menu"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
              >
                {pages.map((page) => (
                  <MenuItem
                    key={page.label}
                    onClick={() => {
                      navigate(page.route);
                      handleCloseNavMenu();
                    }}
                  >
                    <Typography textAlign="center">{page.label}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
};

export default Navbar;